import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { calculateOrderTotal } from "../utils/shipping";
import { FiX, FiPlus, FiMinus, FiTrash2 } from "react-icons/fi";
import "./CartDrawer.css";

export default function CartDrawer() {
    const { items, isOpen, setIsOpen, removeItem, updateQuantity, shippingSettings } = useCart();
    const { subtotal, shipping, total } = calculateOrderTotal(items, shippingSettings);

    return (
        <>
            <div className={`cart-overlay ${isOpen ? "show" : ""}`} onClick={() => setIsOpen(false)} />
            <div className={`cart-drawer ${isOpen ? "open" : ""}`}>
                <div className="cart-header">
                    <h3>Your Cart ({items.reduce((s, i) => s + i.quantity, 0)})</h3>
                    <button onClick={() => setIsOpen(false)} className="close-btn"><FiX size={20} /></button>
                </div>

                <div className="cart-items">
                    {items.length === 0 ? (
                        <p className="cart-empty">No items in your cart yet.</p>
                    ) : (
                        items.map(item => {
                            // Support both old (id) and new (cartId) keys
                            const key = item.cartId || item.id;
                            return (
                                <div key={key} className="cart-item">
                                    <img src={item.imageUrl} alt={item.title} />
                                    <div className="cart-item-info">
                                        <p className="cart-item-title">{item.title}</p>
                                        {/* Show format variant + language badges */}
                                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 4 }}>
                                            {item.selectedFormat && (
                                                <span style={{
                                                    fontSize: 10, fontWeight: 700, padding: "2px 7px",
                                                    borderRadius: 4, background: item.isDigital ? "#e8f4f0" : "#f4ede8",
                                                    color: item.isDigital ? "#1a6b4a" : "#8b4513",
                                                    textTransform: "uppercase", letterSpacing: 0.5
                                                }}>
                                                    {item.selectedFormat === "Bundle" ? `${item.bundleDelivery === "Combo" ? "Physical + Digital" : (item.bundleDelivery || "Physical")} Bundle` : item.selectedFormat}
                                                </span>
                                            )}
                                            {!item.selectedFormat && item.isDigital && (
                                                <span className="badge badge-digital">Digital</span>
                                            )}
                                            {item.language && (
                                                <span style={{
                                                    fontSize: 10, fontWeight: 700, padding: "2px 7px",
                                                    borderRadius: 4, background: "#f0e6ff", color: "#7c3aed",
                                                    textTransform: "uppercase", letterSpacing: 0.5
                                                }}>
                                                    {item.language === "Spanish" ? "🇵🇷 ES" : "🇺🇸 EN"}
                                                </span>
                                            )}
                                        </div>
                                        <p className="cart-item-price">${(item.price * item.quantity).toFixed(2)}</p>
                                        <div className="qty-controls">
                                            <button onClick={() => updateQuantity(key, item.quantity - 1)}><FiMinus size={12} /></button>
                                            <span>{item.quantity}</span>
                                            <button onClick={() => updateQuantity(key, item.quantity + 1)}><FiPlus size={12} /></button>
                                        </div>
                                    </div>
                                    <button className="remove-btn" onClick={() => removeItem(key)}><FiTrash2 size={16} /></button>
                                </div>
                            );
                        })
                    )}
                </div>

                {items.length > 0 && (
                    <div className="cart-footer">
                        <div className="cart-summary">
                            <div className="summary-row"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
                            <div className="summary-row"><span>Shipping</span><span>${shipping.toFixed(2)}</span></div>
                            <div className="summary-row"><span>Tax</span><span>$0.00</span></div>
                            <div className="summary-row total"><span>Total</span><span>${total.toFixed(2)}</span></div>
                        </div>
                        <Link to="/checkout" className="btn-primary checkout-btn" onClick={() => setIsOpen(false)}>
                            Proceed to Checkout
                        </Link>
                    </div>
                )}
            </div>
        </>
    );
}